<template>
    <el-dialog
        v-dialogDrag
        append-to-body
        :closeOnClickModal="false"
        class="reviewManageAttachment receiptSignattachment"
        :title="title"
        :visible="true"
        :before-close="handleClose"
        top="7%"
        width="60%"
    >
        <div class="contentBox">
            <div class="contentBox-img">
                <div class="attachmentTitle" v-if="imgArr.length">
                    <span>{{ info.updateUserName ? '上传人：' + info.updateUserName : '' }}</span>
                    <div style="padding-left: 70px">
                        {{ carouselIndex + 1 + ' / ' + imgArr.length }}
                    </div>
                    <span>{{ info.updateTime ? '上传时间：' + info.updateTime : '' }}</span>
                </div>
                <div v-else class="no-data">暂无附件信息</div>
                <div class="attachmentLeft" v-show="imgArr.length">
                    <div style="height: 400px">
                        <ul id="viewers" style="display: none">
                            <li v-for="(item, index) in imgArr" :key="index">
                                <img :src="item.path" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="contentBox-remark">
                <div class="ai-text">
                    <span class="bold">客户订单号：</span>
                    <span>{{ info.customerOrderNo }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">运输单号：</span>
                    <span>{{ info.taskNo }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">AI识别附件结果：</span>
                    <span :class="['probability-text', info.aiResult === '00' ? 'pass-color' : 'fail-color']" v-show="!!info.aiResult">
                        {{ info.aiResultName || '-' }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">AI识别重合率（%）：</span>
                    <span>{{ info.aiOverlap || '-'  }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">AI识别附件描述：</span>
                    <span>{{ info.aiDescription || '-'  }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">AI自动签收结果：</span>
                    <span :class="['probability-text', info.abnormalAiResult === '00' ? 'pass-color' : 'fail-color']" v-show="!!info.abnormalAiResult">
                        {{ info.abnormalAiResultName || '-' }}</span>
                </div>
                <div class="ai-text">
                    <span class="bold">AI自动签收描述：</span>
                    <span>{{ info.abnormalAiDescription || '-'  }}</span>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
    name: 'imgShowDialog',
    props: {
        title: {
            type: String,
            default () {
                return '';
            }
        },
        attachmentShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        imgArr: {
            type: Array,
            default () {
                return [];
            }
        },
        fileIndex: {
            type: Number,
            default () {
                return 0;
            }
        }
    },
    data () {
        return {
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            info: {}
        };
    },
    mounted () {
        this.updateViewer();
    },
    methods: {
        handleClose () {
            this.$emit('handleClose', 'attachmentShow');
        },
        updateViewer () {
            this.carouselIndex = this.fileIndex;
            this.updateInfo();
            this.$nextTick(() => {
                this.initViewer();
            });
        },
        updateInfo () {
            this.info = this.imgArr[this.carouselIndex];
        },
        initViewer () {
            const barOptions = { show: true, size: 'default' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                title: false,
                inline: true,
                navbar: true,
                zIndexInline: 10086,
                backdrop: true, // 透明背景色
                zoomOnWheel: true, // 滚动缩放
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    oneToOne: barOptions,
                    reset: barOptions,
                    prev: {
                        show: true,
                        size: 'default',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                return this.$message.warning('当前图片是第一张');
                            } else {
                                this.carouselIndex -= 1;
                                this.viewer.prev(true);
                            }
                        }
                    },
                    play: barOptions,
                    next: {
                        show: true,
                        size: 'default',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                return this.$message.warning('当前图片是最后一张');
                            } else {
                                this.carouselIndex += 1;
                                this.viewer.next(true);
                            }
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions,
                    flipHorizontal: barOptions,
                    flipVertical: barOptions
                },
                viewed: (data) => { // 图片加载完成时回调
                    this.carouselIndex = data.detail.index;
                    this.updateInfo();
                }
            });
            this.viewer.view(this.fileIndex);
        }
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>

<style lang="less" scoped>
.reviewManageAttachment {
    .contentBox {
        display: flex;
        .contentBox-img {
            height: 436px;
            width: 60%;
            overflow: hidden;
            .attachmentTitle {
                margin: 10px 0;
                display: flex;
                justify-content: space-between;
            }

            .attachmentLeft {
                position: relative;

                .loadingBox {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: #fff;
                    z-index: 1000;

                    .progress {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                .carousel {
                    text-align: center;

                    .receiveImgs {
                        height: 100%;
                    }
                }
            }
        }

        .contentBox-remark {
            // flex: 1;
            min-width: 350px;
            padding-top: 30px;
            margin-left: 20px;
            >div {
                font-size: 14px;
            }
            .ai-text {
                width: 350px;
                font-size: 14px;
                margin-top: 10px;
                margin-bottom: 15px;
                text-align: left;
                overflow: hidden;
            }
            .bold {
                font-weight: bold;
            }
            .probability-text {
                padding: 6px;
                border-radius: 6px;
            }
            .pass-color {
                background-color: #FF4500;
                color: #fff;
            }
            .fail-color {
                // background-color: #00bcbf;
                background-color: #00CD00;
                color: #fff;
            }
            .reason-text {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 15;
                overflow: hidden;
                white-space: normal;
            }
        }

        .no-data {
            text-align: center;
        }
    }

}
</style>
